import { render, staticRenderFns } from "./ProductSerials.vue?vue&type=template&id=05011ca0"
import script from "./ProductSerials.vue?vue&type=script&lang=js"
export * from "./ProductSerials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports